module.exports = __webpack_public_path__ + "img/Drink.ca6a7e04.svg";